import Section from "@/Components/LayoutComponents/Section";
import React from "react";
import UseCasesSlider from "./UseCasesSlider";
import Image from "next/image";
import { toWebp } from "@/utils/common";

interface UseCasesProps {
  data?: any;
  isMobile?: boolean;
}

const UseCases: React.FC< UseCasesProps> = ({ data, isMobile  }) =>  {
  const title = data?.title || "AI Use Cases & Industry Applications";
  const backgroundImage = "/images/ServicesInner/AIUseCases.png";
  return (
    <Section className="bg-background-dark relative overflow-hidden">
      <div className=" bg-[url(/image/ServicesInner/use cases.png)] bg-size-[60%] bg-no-repeat bg-left-top absolute z-[2] top-0 left-0 inset-0"></div>

      <Image
        src="/images/ServicesInner/Usecases_up_left.png"
        width={500}
        height={500}
        alt="banner-vector"
        className="absolute aspect-square w-[571px] top-5 left-10 z-0 bg-cover bg-no-repeat bg-center"
        quality={80}
        loading="lazy"
      />
      <Image
        src="/images/ServicesInner/Use cases_blue.png"
        width={748}
        height={748}
        alt="banner-vector"
        className="absolute aspect-square w-[748px] top-0 left-0 z-0 bg-contain bg-no-repeat bg-center"
        quality={80}
        loading="lazy"
      />
      <Image
        src="/images/ServicesInner/Usecases_down_right.png"
        width={500}
        height={50}
        alt="banner-vector"
        className="absolute aspect-square w-[865px] -bottom-80 -right-10 z-0 bg-cover bg-no-repeat bg-center"
        quality={100}
        loading="lazy"
      />
      <Image
        src="/images/ServicesInner/Use cases_green.png"
        width={500}
        height={500}
        alt="banner-vector"
        className="absolute aspect-square w-[865px] bottom-0 right-0 z-0 bg-cover bg-no-repeat bg-center"
        quality={80}
        loading="lazy"
      />
      <div
        className={`bg-[url(${toWebp(backgroundImage)})] bg-no-repeat bg-cover bg-top-left absolute top-0 left-0 w-full h-full z-10`}
      ></div>
      <div className="container relative z-20">
        <div className="max-w-[794px] mx-auto">
          <h2 className="text-heading-1 font-bold text-primary-text-white text-center">
            {title}
          </h2>
        </div>
      </div>
      <div className="relative z-20">
        <UseCasesSlider data={data?.UseCase} isMobile={isMobile} />
      </div>
    </Section>
  );
};
export default UseCases;